export default "__VITE_ASSET__Cx5D3jFI__"